import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import layout from './modules/layout';
import system_accounts from './modules/system_accounts';
import system_account from './modules/system_account';
import inspector_teams from './modules/inspector_teams';
import inspector_team_members from './modules/inspector_team_members';
import distributors from './modules/distributors';
import distributor_clients from './modules/distributor_clients';
import pt_locks from './modules/pt_locks';
import operator from './modules/operator';
import fare_groups from './modules/fare_groups';
import fare_group from './modules/fare_group';
import fare_group_fares from './modules/fare_group_fares';
import fare_group_operators from './modules/fare_group_operators';
import discount from './modules/discount';
import audit_logs from './modules/audit_logs';
import audit_log from './modules/audit_log';
import audit_log_resources from './modules/audit_log_resources';
import account from './modules/account';
import account_additional_details from './modules/account_additional_details';
import account_props from './modules/account_props';
import account_journeys from './modules/account_journeys';
import account_journey from './modules/account_journey';
import account_top_ups from './modules/account_top_ups';
import account_top_up from './modules/account_top_up';
import account_purchases from './modules/account_purchases';
import account_purchase from './modules/account_purchase';
import public_transport from './modules/public_transport';
import municipalities from './modules/municipalities';
import municipality from './modules/municipality';
import municipality_bot_clients from './modules/municipality_bot_clients';
import municipality_bot_client from './modules/municipality_bot_client';
import operator_bot_clients from './modules/operator_bot_clients';
import bot_clients from './modules/bot_clients';
import bot_client from './modules/bot_client';
import pt_mapping from './modules/pt_mapping';
import pt_zones from './modules/pt_zones';
import pt_stops from './modules/pt_stops';
import pt_stop from './modules/pt_stop';
import notification_config from './modules/notification_config';
import operator_tickets_report from './modules/operator_tickets_report';
import operator_journeys_count_report from './modules/operator_journeys_count_report';
import credit_debit_report from './modules/credit_debit_report';
import operator_journey_stats_report from './modules/operator_journey_stats_report';
import operator_routes_stats_report from './modules/operator_routes_stats_report';
import money_claim from './modules/money_claim';
import account_deletions from './modules/account_deletions';
import account_money_claims from './modules/account_money_claims';
import account_money_claim from "./modules/account_money_claim";
import account_deletion from "./modules/account_deletion";
import account_discounts from "./modules/account_discounts";
import account_municipalities from "./modules/account_municipalities";
import account_payment_cards from "./modules/account_payment_cards";
import account_payment_card_creations from "./modules/account_payment_card_creations";
import account_mobile_devices from "./modules/account_mobile_devices";
import account_credit_debit_logs from "./modules/account_credit_debit_logs";
import account_audit_logs from "./modules/account_audit_logs";
import account_audit_log from "./modules/account_audit_log";
import reporting_profiles from "@/store/modules/reporting_profiles";
import reporting_profile from './modules/reporting_profile';
import reporting_profile_report from './modules/reporting_profile_report';
import emv_taps_summary_report from './modules/emv_taps_summary_report';
import emv_success_payments_summary_report from './modules/emv_success_payments_summary_report';
import email_templates from './modules/email_templates';
import tickets_stats from './modules/tickets_stats';
import account_stats from './modules/account_stats';
import account_emails from './modules/account_emails';
import account_inspection_events from './modules/account_inspection_events';
import top_up_stats from './modules/top_up_stats';
import role from './modules/role';
import emails from './modules/emails';
import top_ups from './modules/top_ups';
import psw from './modules/psw';
import card from './modules/card';
import pos_transactions from './modules/pos_transactions';
import pos_transaction from './modules/pos_transaction';
import cards from './modules/cards';
import season_tickets from './modules/season_tickets';
import season_ticket_revisions from './modules/season_ticket_revisions';
import account_season_tickets from './modules/account_season_tickets';
import account_season_ticket from './modules/account_season_ticket';
import account_pos_operations from './modules/account_pos_operations';
import getters from './getters';
import season_tickets_count_report from "@/store/modules/season_tickets_count_report";
import distributors_summary_report from "@/store/modules/distributors_summary_report";
import distributor_report from "@/store/modules/distributor_report";
import sold_season_tickets_report from "@/store/modules/sold_season_tickets_report";
import canceled_season_tickets_report from "@/store/modules/canceled_season_tickets_report";
import inspection_events from "@/store/modules/inspection_events";
import account_cap_limit from "@/store/modules/account_cap_limit";
import account_taps from "@/store/modules/account_taps";
import account_tap from "@/store/modules/account_tap";
import operator_assignees from "@/store/modules/operator_assignees";
import profile from "@/store/modules/profile";
import inspection_locks_report from "@/store/modules/inspection_locks_report";
import journeys_by_stop_municipalities_report from "@/store/modules/journeys_by_stop_municipalities_report";
import distributor_bulk_transactions from "@/store/modules/distributor_bulk_transactions";
import distributor_client_ui from "@/store/modules/distributor_client_ui";
import account_emv_taps from "@/store/modules/account_emv_taps";
import account_emv_tap from './modules/account_emv_tap';
import account_associations from './modules/account_associations';
import account_association from './modules/account_association';
import external_emv_taps from './modules/external_emv_taps';
import external_emv_tap from './modules/external_emv_tap';
import emv_clearings from './modules/emv_clearings';
import emv_clearing from './modules/emv_clearing';
import emv_cut_overs from './modules/emv_cut_overs';
import emv_cut_over from './modules/emv_cut_over';
import account_emv_clearings from "@/store/modules/account_emv_clearings";
import account_emv_clearing from "@/store/modules/account_emv_clearing";
import emv_taps from "@/store/modules/emv_taps";
import emv_tap from "@/store/modules/emv_tap";
import offline_filters from "@/store/modules/offline_filters";
import offline_filter from "@/store/modules/offline_filter";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    profile,
    layout,
    system_accounts,
    system_account,
    inspector_teams,
    inspector_team_members,
    distributors,
    distributor_clients,
    pt_locks,
    role,
    operator,
    operator_assignees,
    fare_groups,
    fare_group,
    fare_group_fares,
    fare_group_operators,
    discount,
    audit_logs,
    audit_log,
    audit_log_resources,
    account,
    account_additional_details,
    account_props,
    account_journeys,
    account_journey,
    account_purchases,
    account_purchase,
    account_taps,
    account_tap,
    account_top_ups,
    account_top_up,
    public_transport,
    municipalities,
    municipality,
    municipality_bot_clients,
    municipality_bot_client,
    operator_bot_clients,
    bot_clients,
    bot_client,
    pt_mapping,
    pt_zones,
    pt_stops,
    pt_stop,
    notification_config,
    operator_tickets_report,
    operator_journeys_count_report,
    credit_debit_report,
    operator_journey_stats_report,
    operator_routes_stats_report,
    reporting_profiles,
    reporting_profile,
    reporting_profile_report,
    emv_taps_summary_report,
    emv_success_payments_summary_report,
    money_claim,
    account_deletions,
    account_money_claims,
    account_money_claim,
    account_deletion,
    account_discounts,
    account_municipalities,
    account_payment_cards,
    account_payment_card_creations,
    account_mobile_devices,
    account_credit_debit_logs,
    account_audit_logs,
    account_audit_log,
    account_cap_limit,
    account_emv_taps,
    account_emv_tap,
    account_emv_clearings,
    account_emv_clearing,
    account_associations,
    account_association,
    email_templates,
    emails,
    top_ups,
    tickets_stats,
    account_stats,
    top_up_stats,
    account_emails,
    psw,
    card,
    pos_transactions,
    pos_transaction,
    cards,
    season_tickets,
    season_ticket_revisions,
    account_season_tickets,
    account_season_ticket,
    account_pos_operations,
    season_tickets_count_report,
    distributors_summary_report,
    distributor_report,
    sold_season_tickets_report,
    canceled_season_tickets_report,
    account_inspection_events,
    inspection_events,
    inspection_locks_report,
    journeys_by_stop_municipalities_report,
    distributor_bulk_transactions,
    distributor_client_ui,
    external_emv_taps,
    external_emv_tap,
    emv_clearings,
    emv_clearing,
    emv_cut_overs,
    emv_cut_over,
    emv_taps,
    emv_tap,
    offline_filters,
    offline_filter,
  },
  state: {},
  mutations: {},
  actions: {},
  getters
})
